import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function MapIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <g stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M1.75 5.5v12l5.25-3 6 3 5.25-3v-12L13 5.5l-6-3-5.25 3ZM13 5.5v12M7 2.5v12" />
      </g>
    </Icon>
  );
}
